import Page from '../../../../../shared/components/PageWrapper'
import { FC } from 'react'
import ContactForm from './ContactForm '

const ContactPage: FC = () => {
  return (
    <Page>
      <ContactForm />
    </Page>
  )
}

export default ContactPage
